import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log("🚀 ~ file: ErrorBoundary.js ~ line 16 ~ ErrorBoundary ~ componentDidCatch ~ errorInfo", errorInfo)
        console.log("🚀 ~ file: ErrorBoundary.js ~ line 17 ~ ErrorBoundary ~ componentDidCatch ~ error", error)
    }

    render() {
        return this.props.children;
    }
}

export default ErrorBoundary;